package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Dominican Republic Flag (20x15dp)
 *
 * - ISO Alpha-2: DO
 * - ISO Alpha-3: DOM
 * - ISO Numeric: 214
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.DominicanRepublic: ImageVector by lazy {
    ImageVector.Builder(
        name = "Dominican Republic:DO:DOM:214:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.75f, 0f)
                horizontalLineTo(11.25f)
                verticalLineTo(6.25f)
                horizontalLineTo(20f)
                verticalLineTo(8.75f)
                horizontalLineTo(11.25f)
                verticalLineTo(15f)
                horizontalLineTo(8.75f)
                verticalLineTo(8.75f)
                horizontalLineTo(0f)
                verticalLineTo(6.25f)
                horizontalLineTo(8.75f)
                verticalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFF4257BF))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(8.75f)
                verticalLineToRelative(6.25f)
                horizontalLineToRelative(-8.75f)
                close()
            }
            path(fill = SolidColor(Color(0xFF4257BF))) {
                moveTo(11.25f, 8.75f)
                horizontalLineToRelative(8.75f)
                verticalLineToRelative(6.25f)
                horizontalLineToRelative(-8.75f)
                close()
            }
            path(fill = SolidColor(Color(0xFF309404))) {
                moveTo(8.523f, 6.944f)
                lineTo(9.145f, 7.004f)
                curveTo(9.039f, 8.116f, 9.177f, 8.585f, 9.402f, 8.585f)
                verticalLineTo(9.21f)
                curveTo(8.624f, 9.21f, 8.384f, 8.396f, 8.523f, 6.944f)
                close()
            }
            path(fill = SolidColor(Color(0xFF309404))) {
                moveTo(11.517f, 6.944f)
                lineTo(10.894f, 7.004f)
                curveTo(11.001f, 8.116f, 10.863f, 8.585f, 10.638f, 8.585f)
                verticalLineTo(9.21f)
                curveTo(11.415f, 9.21f, 11.656f, 8.396f, 11.517f, 6.944f)
                close()
            }
            path(fill = SolidColor(Color(0xFF003994))) {
                moveTo(9.205f, 6.683f)
                horizontalLineToRelative(0.591f)
                verticalLineToRelative(0.923f)
                horizontalLineToRelative(-0.591f)
                close()
            }
            path(fill = SolidColor(Color(0xFF003994))) {
                moveTo(10.114f, 7.779f)
                horizontalLineTo(10.705f)
                verticalLineTo(8.247f)
                curveTo(10.705f, 8.498f, 10.501f, 8.702f, 10.25f, 8.702f)
                horizontalLineTo(10.114f)
                verticalLineTo(7.779f)
                close()
            }
            path(fill = SolidColor(Color(0xFFDE2110))) {
                moveTo(10.068f, 6.625f)
                horizontalLineToRelative(0.591f)
                verticalLineToRelative(0.923f)
                horizontalLineToRelative(-0.591f)
                close()
            }
            path(fill = SolidColor(Color(0xFFDE2110))) {
                moveTo(9.205f, 7.779f)
                horizontalLineTo(9.795f)
                verticalLineTo(8.702f)
                horizontalLineTo(9.659f)
                curveTo(9.408f, 8.702f, 9.205f, 8.498f, 9.205f, 8.247f)
                verticalLineTo(7.779f)
                close()
            }
            path(fill = SolidColor(Color(0xFF00319C))) {
                moveTo(8.959f, 6.631f)
                lineTo(8.541f, 6.166f)
                curveTo(8.982f, 5.769f, 9.443f, 5.563f, 9.916f, 5.563f)
                curveTo(10.39f, 5.563f, 10.85f, 5.769f, 11.292f, 6.166f)
                lineTo(10.874f, 6.631f)
                curveTo(10.539f, 6.33f, 10.222f, 6.188f, 9.916f, 6.188f)
                curveTo(9.611f, 6.188f, 9.293f, 6.33f, 8.959f, 6.631f)
                close()
            }
            path(fill = SolidColor(Color(0xFFDE2110))) {
                moveTo(9.004f, 9.746f)
                lineTo(8.586f, 9.282f)
                curveTo(9.028f, 8.884f, 9.488f, 8.678f, 9.962f, 8.678f)
                curveTo(10.436f, 8.678f, 10.896f, 8.884f, 11.337f, 9.282f)
                lineTo(10.919f, 9.746f)
                curveTo(10.585f, 9.445f, 10.267f, 9.303f, 9.962f, 9.303f)
                curveTo(9.656f, 9.303f, 9.339f, 9.445f, 9.004f, 9.746f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun DominicanRepublicPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.DominicanRepublic,
            contentDescription = "Dominican Republic Flag"
        )
    }
}
